module.exports = __webpack_public_path__ + "assets/img/frank-van-rest.80127728.jpg";